import { useCookies } from "react-cookie";
import Header from "../Components/Header/Header";
import { useEffect, useState } from "react";
import "./Students.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PeopleList from "../Components/PeopleList/PeopleList";
import { faCircleExclamation, faDoorOpen, faEllipsis, faEnvelopeOpen, faFlagCheckered, faListOl, faPencilAlt, faPlus, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { faCircleCheck, faCircleXmark, faStar, faUser, faEnvelope } from "@fortawesome/free-regular-svg-icons";

const Students = ({ data, socket } : { data: any, socket: any }) => {

    const [cookies, setCookie] = useCookies();
    const [students, setStudents] = useState<Array<Object>>([]);
    const navigate = useNavigate();
    // alert(data.userData.type);
    if (data.userData.type !== "teacher") navigate(-1);

    useEffect(() => {
        (async () => {
            const options = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                },
            };

            const request = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/teacher/get-students/${data.userData.userId}`, options);
            const response = await request.json();
            if (response.success) setStudents(response.students);
        })();
    }, []);

    const removeStudent = async (userId : string) => {
        const options = {
            method: "DELETE",
            headers: {
                "Content-Type" : "application/json"
            }
        };

        try {
            const request = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/teacher/remove-student/${userId}`, options);
            const response = await request.json();
            
            if (response.success) {
                window.location.reload();
            }
        } catch (e) {
        }
    };

    return (
        <div className="students-container">
            <Header data={data} socket={socket} />

            <h2 className="title">{cookies.language === "en" ? "Students" : "Elevi"}</h2>

            <PeopleList
                people={students as any}
                en={cookies?.language === "en"}
                emptyText={cookies?.language === "en" ? "No students yet." : "Niciun elev deocamdată."}
                onEdit={(p) => navigate(`/edit-student/${p.userId}`)}
                onRemove={(p) => removeStudent(p.userId)}
            />

            <div className="add-button" onClick={() => navigate("/create-student")} style={{ opacity: 1, cursor: "pointer" }}>
                <FontAwesomeIcon icon={faPlus} className="add-icon" />
                <p>{cookies?.language === "en" ? "Add student" : "Adauga elev"}</p>
            </div>    
          
        </div>
    );
};

export default Students;